import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CejV2AdvantagesModule } from '@domains/cej-v2/cej-v2-advantages/cej-v2-advantages.component';
import { CejV2AllocationModule } from '@domains/cej-v2/cej-v2-allocation/cej-v2-allocation.component';
import { CejV2ContactModule } from '@domains/cej-v2/cej-v2-contact/cej-v2-contact.component';
import { CejV2DownloadAppModule } from '@domains/cej-v2/cej-v2-download-app/cej-v2-download-app.component';
import { CejOrientationFormModule } from '@domains/cej-v2/cej-v2-form/cej-orientation-form/cej-orientation-form.component';
import { CejHeroModule } from '@domains/cej-v2/cej-v2-hero/hero.component';
import { CejV2TestimonialsModule } from '@domains/cej-v2/cej-v2-testimonials/cej-v2-testimonials.component';
import { CejV2WhatIsItModule } from '@domains/cej-v2/cej-v2-what-is-it/cej-v2-what-is-it.component';
import { CejV2Component } from '@features/cej-v2/cej-v2/cej-v2.component';

const routes: Routes = [
  {
    path: '',
    component: CejV2Component,
  },
];

@NgModule({
  declarations: [CejV2Component],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CejV2WhatIsItModule,
    CejHeroModule,
    CejOrientationFormModule,
    CejV2AdvantagesModule,
    CejV2TestimonialsModule,
    CejV2ContactModule,
    CejV2AllocationModule,
    CejV2DownloadAppModule,
  ],
})
export class CejV2Module {}
